import WorkOrderUpgradeDialog from "./views/WorkOrderUpgradeDialog.vue";

const routes = [
  {
    path: "/work-order-upgrade-dialog",
    name: "workOrderUpgradeDialog",
    component: WorkOrderUpgradeDialog,
  },
];

export default routes;
